  (function () {
    var STORAGE_KEY = 'ljs_popup_seen';
    var SHOW_DELAY  = 5000;   // ~5 seconds after entry
    var SUPPRESS_DAYS = 30;   // don't show again for 30 days after close/signup

    // Klaviyo client-side subscription settings
    var KLAVIYO_COMPANY_ID = 'SdJbPE';
    var KLAVIYO_LIST_ID    = 'RKAwtD';
    var KLAVIYO_ENDPOINT   = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(KLAVIYO_COMPANY_ID);
    var KLAVIYO_REVISION   = '2024-10-15';

    // Respect suppression window
    try {
      var seen = localStorage.getItem(STORAGE_KEY);
      if (seen && (Date.now() - parseInt(seen, 10)) < SUPPRESS_DAYS * 864e5) return;
    } catch (e) {}

    var overlay = document.getElementById('ljs-popup-overlay');
    if (!overlay) return;

    var popup      = document.getElementById('ljs-popup');
    var closeBtn   = document.getElementById('ljs-popup-close');
    var form       = document.getElementById('ljs-customer-form');
    var formState  = document.getElementById('ljs-popup-form-state');
    var successEl  = document.getElementById('ljs-popup-success');
    var errorEl    = document.getElementById('ljs-error');
    var submitBtn  = document.getElementById('ljs-submit');
    var firstName  = document.getElementById('ljs-first-name');
    var emailInput = document.getElementById('ljs-email');
    var consent    = document.getElementById('ljs-consent');
    var birthday   = document.getElementById('ljs-birthday');
    var lastFocus  = null;
    var submitted  = false; // true once a signup succeeds -> confirmation is locked open

    function suppress() {
      try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (e) {}
    }

    function openPopup() {
      lastFocus = document.activeElement;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.addEventListener('keydown', onKeydown);
      var first = document.getElementById('ljs-first-name');
      if (first) setTimeout(function () { first.focus(); }, 350);
    }

    function closePopup() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', onKeydown);
      suppress(); // don't reappear this session/for the suppression window
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') { if (submitted) return; closePopup(); return; }
      if (e.key === 'Tab') trapFocus(e);
    }

    // Simple focus trap
    function trapFocus(e) {
      var f = popup.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      f = Array.prototype.filter.call(f, function (el) { return el.offsetParent !== null && !el.disabled; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    closeBtn.addEventListener('click', closePopup);
    overlay.addEventListener('click', function (e) { if (submitted) return; if (e.target === overlay) closePopup(); });

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }

    function isValidEmail(v) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
    }

    // Form submit -> Klaviyo client subscription (email required; name & birthday optional)
    if (form) {
      // We do our own validation so we can show friendly, on-brand messages.
      form.setAttribute('novalidate', 'novalidate');

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (errorEl) errorEl.hidden = true;

        var email = (emailInput && emailInput.value || '').trim();
        if (!email || !isValidEmail(email)) {
          showError('Please enter a valid email address.');
          if (emailInput) emailInput.focus();
          return;
        }

        // Marketing consent is required to record opt-in correctly.
        if (consent && !consent.checked) {
          showError('Please tick the box to confirm you’d like to receive our emails.');
          if (consent) consent.focus();
          return;
        }

        // Build the profile. Optional fields are only included when provided,
        // so blank values are never sent and never overwrite an existing profile.
        // Consent: posting to /client/subscriptions for a single opt-in list
        // records email marketing consent (SUBSCRIBED) for this profile.
        var profileAttributes = {
          email: email
        };

        var fn = (firstName && firstName.value || '').trim();
        if (fn) profileAttributes.first_name = fn;

        // Native date inputs always report value as YYYY-MM-DD.
        if (birthday && birthday.value) {
          profileAttributes.properties = { Birthday: birthday.value };
        }

        var payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Website Pop-up (10% Off)',
              profile: { data: { type: 'profile', attributes: profileAttributes } }
            },
            relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } }
          }
        };

        submitBtn.disabled = true;
        var original = submitBtn.textContent;
        submitBtn.textContent = 'Signing you up…';

        fetch(KLAVIYO_ENDPOINT, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': KLAVIYO_REVISION
          },
          body: JSON.stringify(payload)
        })
        .then(function (res) {
          if (res.status === 202 || res.ok) {
            // Success: only shown once the email has been accepted by Klaviyo.
            // Lock the confirmation open. It has no timer and stays visible until the
            // customer dismisses it (X or Start shopping), refreshes, navigates, or
            // closes the tab. Incidental Escape / click-outside no longer close it.
            submitted = true;
            formState.hidden = true;
            successEl.hidden = false;
            var v = document.getElementById('ljs-code-value');
            if (v) { v.setAttribute('tabindex', '-1'); if (v.focus) v.focus(); }
            suppress(); // successful signup -> don't show again
          } else {
            // Never surface technical Klaviyo/API detail to the customer.
            showError('Sorry, we couldn’t sign you up just now. Please try again.');
            submitBtn.disabled = false;
            submitBtn.textContent = original;
          }
        })
        .catch(function () {
          showError('Sorry, we couldn’t sign you up just now. Please try again.');
          submitBtn.disabled = false;
          submitBtn.textContent = original;
        });
      });
    }

    // Copy code
    var copyBtn = document.getElementById('ljs-code-copy');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var code = document.getElementById('ljs-code-value').textContent.trim();
        if (navigator.clipboard) {
          navigator.clipboard.writeText(code).then(function () {
            copyBtn.textContent = 'Copied';
            setTimeout(function () { copyBtn.textContent = 'Copy'; }, 1800);
          });
        }
      });
    }

    var startBtn = document.getElementById('ljs-start-shopping');
    if (startBtn) startBtn.addEventListener('click', closePopup);

    // Show ~5s after entry
    setTimeout(openPopup, SHOW_DELAY);
  })();